export default () => ({
  language: 'nl',
  status: {
    loadingState: false,
    error: '',
    errorSlot: false,
  },
  chassie: '',
  rid: '',
  cat: '',
  regionCode: '',
  postalCode: '',
  region: '',
  tppModal: true,
  licensePlate: '',
  vehiculeType: '', // lease, fleet, part, customer
  bodyworkType: 'car', // car, bus
  tireType: 'tz', // ms == winterband | ts == all season | tz == zomerband
  serviceType: '', // change, new tires, alignment, maintenance
  runFlat: false,
  addresses: [], // Addresses for mobile
  addressId: '',
  depotId: 0,
  searchWatch: '',
  timeOfArrival: '',
  momentsOfTimeOfArrival: ['8:00', '8:30', '9:00', '9:30'],
  // Slot properties
  slotDate: '',
  slotHour: '',
  slotNumber: '',
  slotDuration: '',
  // t1l1 -> t == tire | 1/2 == vooraan/achteraan | l/r == links/rechts | 1/2 == binnenste band/buitste band
  // State -> 0/1/2/3 -> Disabled/Not active/Active/Stock
  tireLocations: {
    t1l1: {
      position: 't1l1',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
    t1r1: {
      position: 't1r1',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
    t2l2: {
      position: 't2l2',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
    t2l1: {
      position: 't2l1',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
    t2r1: {
      position: 't2r1',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
    t2r2: {
      position: 't2r2',
      msStock: 1,
      tzStock: 1,
      tsStock: 1,
    },
  },
  tireStock: {
    tz: 0,
    ms: 0,
    ts: 0,
  },
  tireSizes: {
    frontTire: {
      width: 0,
      height: 0,
      diameter: 0,
      loadCapacity: '',
      speedIndex: '',
    },
    backTire: {
      width: 0,
      height: 0,
      diameter: 0,
      loadCapacity: '',
      speedIndex: '',
    },
  },
  personalData: {
    title: 'Mr.', // Mr. | Ms.
    firstName: '',
    lastName: '',
    email: '',
    cellphoneNumber: '',
    zipCode: '',
    city: '',
    address: '',
    leasingCompanyId: 0,
    company: '',
  },
  regionData: {
    zipCode: '',
    city: '',
    address: '',
  },
  remark: '',
  appointment: {
    addressId: '',
    date: '',
    depotId: 0,
    dateTime: null,
    hour: '',
    hasAppointment: false,
    deliveryNote: '',
    type: '',
    tag: '',
  },
  company: '',
  customerDataRaw: null,
});
